(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gd-contact-hub"] && !Shopify.designMode) return;
  try {
    
function initGroDronesContact(scope = document) {
  scope.querySelectorAll('[data-contact-hub]').forEach(hub => {
    if (hub.dataset.ready) return;
    hub.dataset.ready = 'true';
    const type = hub.querySelector('[data-contact-type]');
    const title = hub.querySelector('[data-contact-title]');
    const intro = hub.querySelector('[data-contact-intro]');
    const send = hub.querySelector('[data-contact-send]');
    const defaults = { title: title.textContent, intro: intro.textContent, send: send?.textContent };
    const inquiryValue = { equipment: 'Equipment sales', order: 'Order support' };
    function selectInquiry(inquiry) {
      const valid = Object.hasOwn(inquiryValue, inquiry);
      if (type) type.value = valid ? inquiryValue[inquiry] : '';
      ['equipment', 'order'].forEach(key => {
        const group = hub.querySelector('[data-contact-' + key + ']');
        if (!group) return;
        group.hidden = valid && key !== inquiry;
        group.querySelectorAll('input').forEach(input => { input.disabled = valid && key !== inquiry; });
      });
      title.textContent = valid ? title.dataset[inquiry + 'Title'] : defaults.title;
      intro.textContent = valid ? intro.dataset[inquiry + 'Intro'] : defaults.intro;
      if (send) send.textContent = valid ? send.dataset[inquiry + 'Send'] : defaults.send;
    }
    function fromUrl() {
      const query = new URLSearchParams(window.location.search).get('inquiry');
      const saved = Object.keys(inquiryValue).find(key => inquiryValue[key] === type?.value);
      selectInquiry(Object.hasOwn(inquiryValue, query) ? query : saved || '');
    }
    if (type) type.addEventListener('change', () => {
      const key = Object.keys(inquiryValue).find(value => inquiryValue[value] === type.value) || '';
      const url = new URL(window.location.href);
      if (key) url.searchParams.set('inquiry', key);
      else url.searchParams.delete('inquiry');
      if (url.hash === '#contact-form') url.hash = '';
      window.history.replaceState(null, '', url);
      selectInquiry(key);
    });
    fromUrl();
    window.addEventListener('popstate', fromUrl);
  });
}
initGroDronesContact();
document.addEventListener('shopify:section:load', event => initGroDronesContact(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-store-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-gd-menu][open]');
    if (menu) {
      menu.open = false;
      menu.querySelector(':scope > summary')?.focus();
      event.stopPropagation();
    }
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-gd-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
